import React, { useState } from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';

const SectionContainer = styled.div`
  margin-bottom: 8px;
  border-radius: 4px;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: ${props => props.theme?.sectionHeaderBg || '#2a2a2a'};
  color: ${props => props.theme?.sectionHeaderColor || '#fff'};
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${props => props.theme?.sectionHeaderHoverBg || '#333'};
  }
`;

const SectionTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const ChevronIcon = styled(Icon)`
  transition: transform 0.2s;
  transform: ${props => props.expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

const SectionContent = styled.div`
  padding: ${props => props.expanded ? '16px' : '0'};
  max-height: ${props => props.expanded ? '5000px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s ease-out;
  background-color: ${props => props.theme?.sectionContentBg || '#1f1f1f'};
`;

export const CollapsibleSection = ({ 
  title, 
  children, 
  defaultExpanded = false,
  onToggle,
  ...props 
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    if (onToggle) {
      onToggle(newState);
    }
  };

  return (
    <SectionContainer {...props}>
      <SectionHeader onClick={handleToggle}>
        <SectionTitle>{title}</SectionTitle>
        <ChevronIcon type="down" expanded={isExpanded} />
      </SectionHeader>
      <SectionContent expanded={isExpanded}>
        {children}
      </SectionContent>
    </SectionContainer>
  );
};


